export function verificarSeExisteDependentePet (dependentes = []) {
    return dependentes.findIndex(dependente=> dependente['GrauParentesco.Grau']?.trim() === 'PET');
}

export function verificarSubGrupoJaVendePet (subGrupo = '') {
    const arrayDePlanosQueJaVendemPet = ['ZP','ZP4','ZPA','ZPC','ZPC4','ZPCA', 'ZPET'];

    return arrayDePlanosQueJaVendemPet.includes(subGrupo);
}